import React from 'react'

function About(props) {
	return (
		<div>
			<h1>About</h1>
			<p>Work in progress</p>
		</div>
	)
}

export default About
